import {Component, Input, Output, EventEmitter, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, Subscription, find } from 'rxjs';
import HashMap from 'src/app/types/hash-map';
import { UPDATE_SUBSTATUS } from './graphql/substatuses';
import { SubStatusesService } from './sub-statuses.service';
import {WarehouseLineComponent} from "../warehouse-line/warehouse-line.component";

@Component({
    selector: 'sub-statuses',
    templateUrl: './sub-statuses.component.html',
    styleUrls: ['./sub-statuses.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubStatusesComponent {
  @Input() currentStatus: string | null;
  @Input() statusSequence: any;
  @Input() subsequences: any[];
  @Input() projectId: string;
  @Input() projectSubstatuses: any[];
  @Input() projectSubstatusDates: any[];
  @Input() projectCredits:any[];

  @Output() changeProjectSubstatuses = new EventEmitter();
  @ViewChild(WarehouseLineComponent) warehouseComponent: WarehouseLineComponent

  public activeSubsequences: Observable<any[]>;
  public projectSubstatuses$: Observable<any[]>;
  public editModeTable: boolean = false;
  public editModeWarehouse: boolean = false;
  public editModeSubsequence: HashMap<boolean> = {};
  public activeSubsequenceSubscription: Subscription;
  public hasSubsequences: boolean = false;
  public hasActiveSubsequence: boolean = false;
  public anyEditPermissions: boolean = false;
  public savingProjectSubstatuses: boolean = false;

  public subsequenceCurrentIndices: HashMap<string> = {};
  public projectSubstatusSub: Subscription;
  public savingProjectSubstatusesSub: Subscription;
  public projectSubstatusDates$: Observable<any[]>;

  constructor(
    public apollo: Apollo,
    public substatusService: SubStatusesService
  ) {}

  ngOnInit() {
    this.savingProjectSubstatusesSub = this.substatusService
      .getSavingProjectSubstatuses()
      .subscribe((saving: boolean) => (this.savingProjectSubstatuses = saving));
    this.substatusService.setInitialData(
      this.projectSubstatuses,
      this.projectSubstatusDates,
      this.subsequences
    );
    this.activeSubsequences = this.substatusService.getActiveSequences(
      this.currentStatus
    );
    if (this.activeSubsequences) {
      this.activeSubsequenceSubscription = this.activeSubsequences.subscribe(
        (subsequences: any[]) => {
          this.hasActiveSubsequence = subsequences?.length > 0;
        }
      );
    }
    this.anyEditPermissions = !!this.subsequences
      .filter((subsequence: any) => this.filterSubsequences(subsequence))
      .find((subsequence) => subsequence?.permissions?._edit);
    this.hasSubsequences = !!this.subsequences.find((subsequence: any) =>
      this.filterSubsequences(subsequence)
    );
    this.projectSubstatuses$ = this.substatusService.getProjectSubstatuses();
    this.projectSubstatusSub = this.projectSubstatuses$.subscribe(
      (projectSubstatuses) => {
        this.handleSubsequenceUpdate(this.subsequences, projectSubstatuses);
      }
    );
    this.projectSubstatusDates$ =
      this.substatusService.getProjectSubstatusDates();
  }
  ngOnDestroy() {
    this.activeSubsequenceSubscription?.unsubscribe();
    this.projectSubstatusSub?.unsubscribe();
    this.savingProjectSubstatusesSub.unsubscribe();
  }
  handleSubsequenceUpdate(activeSubsequences: any[], projectSubstatuses: any) {
    for (let i = 0; i < activeSubsequences.length; i++) {
      let subsequence = activeSubsequences[i];
      let projectSubstatus = projectSubstatuses.find(
        (projectSubstatus: any) =>
          projectSubstatus.subsequence_id === subsequence.id &&
          projectSubstatus.project_status_id ===
            this.statusSequence.projectStatusID
      );
      if (projectSubstatus) {
        let substatus = subsequence.substatuses.find(
          (substatus: any) => substatus.id === projectSubstatus.substatus_id
        );
        this.subsequenceCurrentIndices[subsequence.id] =
          substatus?.statusSubstatuses.find(
            (statusSubstatus: any) =>
              statusSubstatus.status_id === this.currentStatus
          )?.index;
      }
    }
  }
  filterSubsequences(subsequence: any) {
    return subsequence.substatuses.find((substatus: any) =>
      substatus.statusSubstatuses.find(
        (statusSubstatus: any) =>
          statusSubstatus.status_sequence_id === this.statusSequence.id
      )
    );
  }
  toggleTableEditMode() {
    if (this.editModeTable) {
      this.substatusService.upsertProjectSubstatusDates();
    }
    this.editModeTable = !this.editModeTable;
  }

  hasWarehouseCredits(){
    let warehousedCredits = this.projectCredits.filter((credit:any) => credit.warehoused==true);
    if(warehousedCredits.length>0){
      return true;
    } else {
      return false;
    }

  }

  toggleWarehouseEditMode(){
    if(this.editModeWarehouse){
      ///update credit outlet
      this.warehouseComponent.updateWarehouseLine()
    }
    this.editModeWarehouse = !this.editModeWarehouse
  }
  toggleEditMode(subsequence: any) {
    if (this.editModeSubsequence[subsequence.id]) {
      this.substatusService.upsertProjectSubstatusDates();
      this.editModeSubsequence[subsequence.id] = false;
    } else {
      this.editModeSubsequence[subsequence.id] = true;
    }
  }
  handleClick(substatus: any, subsequence: any): void {
    this.substatusService.upsertProjectSubstatus(
      substatus,
      subsequence,
      this.statusSequence.projectStatusID
    );
  }
}
